/**
 * Einstiegspunkt der REVX-PWA.
 * Lädt persistierte Konfiguration und startet die UI.
 */
import './styles.css'
import { loadPersisted } from './state/store.js'
import { initUi } from './ui.js'

loadPersisted()

// Nur im Dev-Modus: State + Physik für Debugging/Verifikation zugänglich machen.
if (import.meta.env.DEV) {
  Promise.all([import('./state/store.js'), import('./sim/physics.js')]).then(([store, physics]) => {
    window.__revx = { ...store, stepPhysics: physics.stepPhysics }
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initUi, { once: true })
} else {
  initUi()
}
